import { h, createContext } from 'preact'
import { useContext, useCallback } from 'preact/hooks'
import { useCallManager } from 'lib/useCallManager'
import CallNotificationPopup from 'components/CallNotificationPopup'
import CallAlertBanner from 'components/CallAlertBanner'
import ActiveCallOverlay from 'components/ActiveCallOverlay'

const CallContext = createContext(null)

export function GlobalCallProvider({
  myPublicProfileDid,
  myDisplayName,
  children,
}) {
  const callManager = useCallManager({
    myPublicProfileDid,
    myDisplayName,
  })

  const handleLeaveCall = useCallback(() => {
    callManager.leaveCall()
  }, [callManager.leaveCall])

  const isAdmin = !!callManager.outgoingCall

  return (
    <CallContext.Provider value={callManager}>
      {children}

      {callManager.incomingCall && (
        <CallNotificationPopup
          callerName={callManager.incomingCall.callerName}
          chatName={callManager.incomingCall.chatName}
          organizationApikey={callManager.incomingCall.organizationApikey}
          callType={callManager.incomingCall.callType}
          isGroupCall={callManager.incomingCall.isGroupCall}
          onAccept={callManager.acceptCall}
          onDecline={callManager.declineCall}
        />
      )}

      {callManager.callAlerts.length > 0 && (
        <CallAlertBanner
          alerts={callManager.callAlerts}
          onDismiss={callManager.dismissAlert}
          onDismissAll={callManager.dismissAllAlerts}
        />
      )}

      {callManager.activeCall && (
        <ActiveCallOverlay
          callData={{
            ...callManager.activeCall,
            isInitiator: isAdmin,
            callerName: callManager.incomingCall
              ? callManager.incomingCall.callerName
              : myDisplayName,
            chatName: callManager.incomingCall
              ? callManager.incomingCall.chatName
              : (callManager.outgoingCall ? callManager.outgoingCall.chatName : ''),
          }}
          onLeave={handleLeaveCall}
          myDisplayName={myDisplayName}
          isAdmin={isAdmin}
        />
      )}
    </CallContext.Provider>
  )
}

export function useGlobalCall() {
  return useContext(CallContext)
}
